"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'StoreAttr',
  data: function data() {
    return {
      formDynamic: {
        ruleName: '',
        ruleValue: []
      },
      tableFrom: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      keywords: '',
      tableData: {
        data: [],
        loading: false,
        total: 0
      },
      listLoading: false,
      selectionList: [],
      multipleSelectionAll: [],
      idKey: 'id',
      nextPageFlag: false,
      keyNum: 0
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:product:rule:page:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    add: function add() {
      var _this = this;
      this.$modalAttr(Object.assign({}, this.formDynamic), function () {
        _this.getList();
      }, this.keyNum += 1);
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      (0, _product.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        _this2.tableData.data = list;
        _this2.tableData.total = res.total;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this3 = this;
      this.$modalSure().then(function () {
        (0, _product.attrDeleteApi)(id).then(function () {
          _this3.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this3.tableData.data.length, _this3.tableFrom);
          _this3.getList();
        });
      }).catch(function () {});
    },
    handleDeleteAll: function handleDeleteAll() {
      var _this4 = this;
      if (!this.multipleSelectionAll.length) return this.$message.warning('请选择商品规格');
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.ids = data.join(',');
      this.$modalSure().then(function () {
        (0, _product.attrDeleteApi)(_this4.ids).then(function () {
          _this4.$message.success('删除成功');
          _this4.getList();
        });
      }).catch(function () {});
    },
    onEdit: function onEdit(val) {
      var _this = this;
      this.$modalAttr(JSON.parse(JSON.stringify(val)), function () {
        _this.getList();
      });
    }
  }
};